// @flow
import type { Contact } from 'types/contacts';
import type { FSA } from 'types/redux';

export type ContactsState = {
  active?: Contact,
  newlyCreatedID: ?number,
};

export const defaultContactsState = {
  newlyCreatedID: null,
};

const contact = (state: ContactsState = defaultContactsState, action: FSA): ContactsState => {
  // skeleton for contacts reducer
  switch (action.type) {
    default:
      return state;
  }
};

export default contact;
